<template>
  <div>
    <b-card>
      <b-row v-if="!isRequestTable">
        <b-col
          cols="12"
          md="6"
          class="py-1"
        >
          <SearchInputAction
            v-if="normalSearch"
            :data-load="dataLoad"
            :view-search-input="viewSearchInput"
            :get-all-data="getAllData"
          />
          <div class="d-flex py-1">
            <ManufactureTemplateDownload
              v-if="needManufactureTemplateDownload"
            />
            <ManufactureTemplateImport
              v-if="needManufactureTemplateImport"
            />
          </div>

        </b-col>
        <b-col
          v-if="!dataLoad"
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end py-1"
        >

          <b-button
            v-if="addType.length"
            ref="actions"
            variant="primary"
            class="ml-auto mr-1"
            @click="goToPageOrOpenModal()"
          >
            <span class="text-nowrap"> {{ addType }} </span>
          </b-button>

          <b-button
            v-if="addUrlLink.length"
            ref="actions"
            variant="primary"
            class="ml-auto mr-1"
          >
            <a
              :href="addUrlLink"
              target="_blank"
              class="text-nowrap text-white"
            > {{ addComponentName }} </a>
          </b-button>
          <IndexExecl
            :need-excel="needExcel"
            :need-payroll-excel="needPayrollExcel"
            :need-user-excel="needUserExcel"
            :skip-page="skipPage"
          />

        </b-col>
      </b-row>

      <FilterUser
        v-if="filterUserSite"
        :data-load="dataLoad"
        :get-all-data="getAllData"
      />
      <!-- @handleRole="handleRole" -->
      <FilterManufactureWhite
        v-if="filterManufactureWhite"
        :data-load="dataLoad"
        :get-all-data="getAllData"
        @handleActivities="handleActivities"
        @handleActivitiesProduct="handleActivitiesProduct"
        @handleStatus="handleStatus"
        @handleSearchOnly="handleSearchOnly"
      />

      <FilterTaskManagement
        v-if="filterTaskManagement"
        :data-load="dataLoad"
        :get-all-data="getAllData"
        @handleTaksStatus="handleTaksStatus"
        @handlePriority="handlePriority"
        @handleSearchOnly="handleSearchOnly"
      />

      <FilterAudit
        v-if="filterAudit"
        :data-load="dataLoad"
        :get-all-data="getAllData"
      />

      <FilterPayroll
        v-if="filterPayroll"
        :data-load="dataLoad"
        :get-all-data="getAllData"
      />

      <b-row>
        <b-col md="12">
          <div
            v-if="dataLoad"
            class=" text-center my-2"
          >
            <b-spinner
              type="grow"
              label="Loading..."
            />
          </div>
          <b-table
            v-else
            ref="generalTable"
            :key="tableDataKey"
            :items="rows"
            :fields="columns"
            :per-page="perPage"
            aria-busy="true"
            class="position-relative"
            responsive
            show-empty
            bordered
            sticky-header
            primary-key="id"
            :no-local-sorting="true"
            @row-clicked="handleRowClick"
          >
            <!-- :current-page="page" -->
            <template
              v-for="(_, slotName) of $scopedSlots"
              v-slot:[slotName]="scope"
            >
              <slot
                :name="slotName"
                v-bind="scope"
              />
            </template>
            <template #thead-top>
              <tr>
                <th
                  v-for="(topHead, index) in topHeader"
                  :key="index"
                  :colspan="topHead.colspan"
                  class="main-header-table"
                >
                  {{ topHead.lable }}
                </th>
              </tr>
              <tr />
            </template>

            <template #cell(actions)="data">
              <slot
                name="actions"
                v-bind="data"
              >
                <div class="space-icons">
                  <PostEntryAction
                    v-if="postContent"
                    :data="data"
                    :get-all-data="getAllData"
                    :api-url="apiUrl"
                  />

                  <PostContentAction
                    v-if="postContent"
                    :data="data"
                  />

                  <ViewContentAction
                    v-if="viewContent"
                    :data="data"
                    :viw-component="viwComponent"
                  />

                  <EditContentAction
                    v-if="editContent"
                    :edit-component="editComponent"
                    :data="data"
                    :type="type"
                  />

                  <DeleteContentAction
                    v-if="deleteContent"
                    :data="data"
                    :api-url="apiUrl"
                    :get-all-data="getAllData"
                  />

                  <CancelContentAction
                    v-if="cancelContent"
                    :data="data"
                    :api-url="apiUrl"
                    :get-all-data="getAllData"
                  />

                </div>
              </slot>
            </template>

            <template #cell(name)="data">
              <span style="font-size: smaller; text-wrap: nowrap">
                {{ data.item.name }}
              </span>
            </template>

          </b-table>
        </b-col>

        <!-- //////////////////////////// pagination //////////////////////////// -->
      </b-row>
      <div class="mx-2 mb-2">
        <Pagination
          v-if="!haveRequests"
          :page="page"
          :per-page="perPage"
          :total-rows="totalRows"
          @get-all-data="getAllData"
        />
        <div>
          <b-spinner
            v-if="paginationLoading"
            label="Spinning"
          />
          <span v-else>

            <Pagination
              v-if="haveRequests"
              :page="page"
              :per-page="perPage"
              :total-rows="requestTotalRows"
              @get-all-data="getAllData"
            />
          </span>

        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapMutations } from 'vuex'
import decryptData from '@/store/auth/decryptData'
import FilterUser from './filter-by/FilterUser.vue'
import FilterManufactureWhite from './filter-by/FilterManufactureWhite.vue'
import FilterTaskManagement from './filter-by/FilterTaskManagement.vue'
// import FilterRequest from './filter-by/FilterRequest.vue'
import IndexExecl from './specific-action/IndexExecl.vue'
import PostEntryAction from './actions/PostEntryAction.vue'
import PostContentAction from './actions/PostContentAction.vue'
import ViewContentAction from './actions/ViewContentAction.vue'
import EditContentAction from './actions/EditContentAction.vue'
import DeleteContentAction from './actions/DeleteContentAction.vue'
import CancelContentAction from './actions/CancelContentAction.vue'
import SearchInputAction from './actions/SearchInputAction.vue'
import buildParams from './specific-utils/buildParams'
import Pagination from './specific-utils/Pagination.vue'
import FilterAudit from './filter-by/FilterAudit.vue'
import FilterPayroll from './filter-by/FilterPayroll.vue'
import ManufactureTemplateDownload from './actions/ManufactureTemplateDownload.vue'
import ManufactureTemplateImport from './actions/ManufactureTemplateImport.vue'

export default {
  components: {
    ManufactureTemplateDownload,
    ManufactureTemplateImport,
    PostEntryAction,
    PostContentAction,
    ViewContentAction,
    EditContentAction,
    DeleteContentAction,
    CancelContentAction,
    FilterUser,
    // FilterRequest,
    SearchInputAction,
    FilterManufactureWhite,
    Pagination,
    FilterTaskManagement,
    FilterAudit,
    FilterPayroll,
    IndexExecl,
  },
  props: {
    needManufactureTemplateDownload: {
      type: Boolean,
      default: () => false,
    },
    haveSidebar: {
      type: Boolean,
      default: false,
    },
    needManufactureTemplateImport: {
      type: Boolean,
      default: () => false,
    },

    filterPayroll: {
      type: Boolean,
      default: () => false,
    },
    filterAudit: {
      type: Boolean,
      default: () => false,
    },
    filterTaskManagement: {
      type: Boolean,
      default: () => false,
    },
    filterManufactureWhite: {
      type: Boolean,
      default: () => false,
    },
    normalSearch: {
      type: Boolean,
      default: () => true,
    },
    topHeader: {
      type: Array,
      default: () => [],
    },
    filterRequest: {
      type: Boolean,
      default: () => false,
    },
    viewSearchInput: {
      type: Boolean,
      default: () => true,
    },
    viewSearchBtn: {
      type: Boolean,
      default: () => false,
    },
    showSelectForSorce: {
      type: Boolean,
      default: () => false,
    },
    showFilterForOffice: {
      type: Boolean,
      default: () => false,
    },
    showFilterForDate: {
      type: Boolean,
      default: () => false,
    },
    showFilterForSource: {
      type: Boolean,
      default: () => false,
    },
    addUrlLink: {
      type: String,
      default: () => '',
    },
    filterUserSite: {
      type: Boolean,
      default: () => false,
    },
    showFilterOptions: {
      type: Boolean,
      default: () => false,
    },
    apiUrl: {
      type: String,
      default: () => '',
    },
    addType: {
      type: String,
      default: () => '',
    },
    addComponentName: {
      type: String,
      default: () => '',
    },
    editComponent: {
      type: String,
      default: () => '',
    },
    viwComponent: {
      type: String,
      default: () => '',
    },
    type: {
      type: String,
      default: () => '',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    needPayrollExcel: {
      type: Boolean,
      default: () => false,
    },
    needUserExcel: {
      type: Boolean,
      default: () => false,
    },
    needExcel: {
      type: Boolean,
      default: () => false,
    },
    viewContent: {
      type: Boolean,
      default: () => true,
    },
    editContent: {
      type: Boolean,
      default: () => true,
    },
    postContent: {
      type: Boolean,
      default: () => false,
    },
    deleteContent: {
      type: Boolean,
      default: () => true,
    },
    cancelContent: {
      type: Boolean,
      default: () => false,
    },
    certificateOptions: {
      type: Array,
      default: () => [],
    },
    selectcertificate: {
      type: Boolean,
      default: () => false,
    },
    selectSubcertificate: {
      type: Boolean,
      default: () => false,
    },
    isRequestTable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selectedItem: [],
      rows: [],
      totalRows: null,
      externalStatuses: [],
      internalStatuses: [],
      page: 1,
      perPage: 20,
      requestTotalRows: null,
      dataLoad: false,
      paginationLoading: false,
      tableDataKey: 0,
      skipPage: 0,
      roleName: null,
      paramExel: {},
      userRole: localStorage.getItem('accessRole'),
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        item: null,
      },
    }
  },
  computed: {
    haveRequests() {
      return this.apiUrl === 'requests' || this.apiUrl === 'requests/over_due'
    },
  },
  mounted() {
    if (this.userRole === 'office-manager') {
      const officeId = localStorage.getItem('office_id')
      this.$router.push({
        query: { ...this.$route.query, office: officeId },
      })
    }
    this.getAllData(this.page)
  },
  methods: {

    handleView() {
      this.handleRowClick(this.contextMenu.item)
      this.hideContextMenu()
    },

    hideContextMenu() {
      this.contextMenu.visible = false
    },
    handleRowClick(item) {
      if (!this.haveSidebar) return
      this.hideContextMenu()
      this.$emit('handle-row-click', item)
    },
    handleCertificateId(id) {
      // this.getIdCertificate = id
      this.$router.push({
        query: { ...this.$route.query, certificate: id },
      })
    },
    handleSubCertificateId(id) {
      this.$router.push({
        query: { ...this.$route.query, sub_certificate: id },
      })
    },
    handleStatus(status) {
      this.$router.push({
        query: { ...this.$route.query, status },
      })
    },
    handleActivities(name) {
      this.$router.push({
        query: { ...this.$route.query, sub_products: name },
      })
    },
    handleActivitiesProduct(name) {
      this.$router.push({
        query: { ...this.$route.query, products: name },
      })
    },
    handlePriority(name) {
      this.$router.push({
        query: { ...this.$route.query, priority: name },
      })
    },
    handleTaksStatus(name) {
      this.$router.push({
        query: { ...this.$route.query, statusTask: name },
      })
    },
    handleSearchOnly(name) {
      this.$router.push({
        query: { ...this.$route.query, search: name },
      })
    },
    goToPageOrOpenModal() {
      if (this.type === 'page') {
        this.$router.push({ name: this.addComponentName })
      } else {
        this.$parent.$refs.genmodal.show()
      }
    },

    ...mapMutations('app', ['setShowFilterRow']),

    async getAllData(page = 1) {
      this.setShowFilterRow(false)

      this.dataLoad = true

      try {
        // need logic for pagination
        const params = buildParams(this, page)
        this.skipPage = params.skip

        this.paramExel = params

        const response = await axios.get(this.apiUrl, { params })

        if (response.status === 200) {
          const responseData = decryptData(response.data.payload)
          // console.log(responseData)

          this.setShowFilterRow(true)
          this.rows = responseData?.data[Object.keys(responseData?.data)[0]]
          this.externalStatuses = responseData?.data?.external_statuses || []
          this.internalStatuses = responseData?.data?.internal_statuses || []
          this.totalRows = responseData.data.count || responseData.data.length
          this.$emit('data-loaded', this.rows, responseData.data)
        }
      } catch (error) {
        if (error.response.status === 500) {
          // console.log(decryptData(error.response.data.payload))
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Server Error',
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        }
      } finally {
        this.dataLoad = false
        // this.setShowFilterRow(false)
      }
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.context-menu {
  position: fixed;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  z-index: 9999;
  border-radius: 6px;
  min-width: 140px;

  ul {
    list-style: none;
    margin: 0;
    padding: 6px 0;
  }

  li {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      background: #f5f5f5;
    }
  }
}
</style>
